import { jsx as p, jsxs as S } from "react/jsx-runtime";
import { PasswordProgressEnum as o, getPasswordStatus as s, getPasswordProgressValue as h } from "./utils.js";
import m from "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import d from "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import "@material-ui/core/Grid";
import "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import l from "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemIcon";
import "@material-ui/core/ListItemText";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import c from "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/createTheme";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import P from "@material-ui/core/styles/withStyles";
import u from "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import "@material-ui/icons/Info";
import "@material-ui/icons/KeyboardArrowLeft";
import "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import "@material-ui/styles/ThemeProvider";
import { Colors as w } from "@propify/components";
import f from "classnames";
const O = {
  [o.OK]: "Strength: strong",
  [o.PASS]: "Strength: medium",
  [o.POOR]: "Strength: too short"
}, y = (t) => c({
  passStrengthEmptyBg: {
    backgroundColor: t.palette.grey[300]
  },
  passStrengthBgOk: {
    backgroundColor: t.palette.success.main
  },
  passStrengthBgPoor: {
    backgroundColor: t.palette.error.main
  },
  passStrengthBgPass: {
    backgroundColor: t.palette.warning.main
  },
  passStrengthFgOk: {
    color: t.palette.success.main
  },
  passStrengthFgPoor: {
    color: t.palette.error.main
  },
  passStrengthFgPass: {
    color: t.palette.warning.main
  },
  passStrengthTextMsg: {
    color: w.darkGrey62,
    fontWeight: "normal",
    lineHeight: 1.33,
    letterSpacing: "0.4px"
  },
  passwordStrength: {
    weight: "bold",
    fontSize: "12px",
    lineHeight: "1.5"
  }
}), B = ({ password: t, classes: r }) => {
  const e = {
    [o.OK]: r.passStrengthBgOk,
    [o.PASS]: r.passStrengthBgPass,
    [o.POOR]: r.passStrengthBgPoor
  }, a = {
    [o.OK]: r.passStrengthFgOk,
    [o.PASS]: r.passStrengthFgPass,
    [o.POOR]: r.passStrengthFgPoor
  }, n = (i) => {
    const g = s(i);
    return i && i.length ? /* @__PURE__ */ p("div", { children: /* @__PURE__ */ p(
      l,
      {
        "data-testid": "password-strength-progress",
        classes: {
          colorPrimary: r.passStrengthEmptyBg,
          bar1Determinate: e[g]
        },
        color: "primary",
        variant: "determinate",
        value: h(i)
      }
    ) }) : null;
  };
  return /* @__PURE__ */ p(m, { mt: 1, children: /* @__PURE__ */ p(d, { children: /* @__PURE__ */ S("div", { className: r.passwordStrength, children: [
    /* @__PURE__ */ p(
      m,
      {
        "data-testid": "password-strength",
        className: f({
          [a[s(t)]]: !0
        }),
        children: O[s(t)]
      }
    ),
    n(t),
    /* @__PURE__ */ p(m, { "data-testid": "password-strength-message", className: r.passStrengthTextMsg, children: "Please enter at least 6 characters and don't use passwords that are easy to guess." })
  ] }) }) });
}, Xt = u(
  P(y, { name: "PasswordStrength" })(B)
);
export {
  Xt as default
};
//# sourceMappingURL=PasswordStrength.js.map
